module.exports = function (t) {
  var e = {};

  function n(r) {
    if (e[r]) return e[r].exports;
    var a = e[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return t[r].call(a.exports, a, a.exports, n), a.l = !0, a.exports;
  }

  return n.m = t, n.c = e, n.d = function (t, e, r) {
    n.o(t, e) || Object.defineProperty(t, e, {
      enumerable: !0,
      get: r
    });
  }, n.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, n.t = function (t, e) {
    if (1 & e && (t = n(t)), 8 & e) return t;
    if (4 & e && "object" == typeof t && t && t.__esModule) return t;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: t
    }), 2 & e && "string" != typeof t) for (var a in t) {
      n.d(r, a, function (e) {
        return t[e];
      }.bind(null, a));
    }
    return r;
  }, n.n = function (t) {
    var e = t && t.__esModule ? function () {
      return t.default;
    } : function () {
      return t;
    };
    return n.d(e, "a", e), e;
  }, n.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }, n.p = "", n(n.s = 6);
}([function (t, e, n) {
  t.exports = n(4)();
}, function (t, e) {
  t.exports = require("react");
}, function (t, e, n) {
  t.exports = function (t) {
    var e = {};

    function n(r) {
      if (e[r]) return e[r].exports;
      var a = e[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return t[r].call(a.exports, a, a.exports, n), a.l = !0, a.exports;
    }

    return n.m = t, n.c = e, n.d = function (t, e, r) {
      n.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, n.t = function (t, e) {
      if (1 & e && (t = n(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var a in t) {
        n.d(r, a, function (e) {
          return t[e];
        }.bind(null, a));
      }
      return r;
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return n.d(e, "a", e), e;
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "", n(n.s = 2);
  }([function (t, e, n) {
    t.exports = n(3)();
  }, function (t, e) {
    t.exports = n(1);
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(1),
        a = n.n(r),
        o = n(0),
        c = n.n(o);

    function i() {
      return (i = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];

          for (var r in n) {
            Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
          }
        }

        return t;
      }).apply(this, arguments);
    }

    function s(t, e) {
      var n = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    function u(t, e, n) {
      return e in t ? Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = n, t;
    }

    var l = Object(r.forwardRef)(function (t, e) {
      var n = t.id,
          r = t.className,
          o = t.style,
          c = t.htmlElement,
          l = t.htmlAttributes,
          p = t.children,
          f = [r, l.className].filter(Boolean).join(" "),
          h = function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? s(Object(n), !0).forEach(function (e) {
            u(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }

        return t;
      }({}, l.style, {}, o);

      return a.a.createElement(c, i({}, l, {
        id: n,
        className: f || void 0,
        style: h,
        ref: e
      }), p && p);
    });
    l.defaultProps = {
      id: void 0,
      className: void 0,
      style: {},
      htmlElement: "div",
      htmlAttributes: {},
      children: void 0
    }, l.propTypes = {
      id: c.a.string,
      className: c.a.string,
      style: c.a.shape({}),
      htmlElement: c.a.string,
      htmlAttributes: c.a.shape({
        id: c.a.string,
        className: c.a.string,
        style: c.a.shape({})
      }),
      children: c.a.node
    }, e.default = l;
  }, function (t, e, n) {
    "use strict";

    var r = n(4);

    function a() {}

    function o() {}

    o.resetWarningCache = a, t.exports = function () {
      function t(t, e, n, a, o, c) {
        if (c !== r) {
          var i = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw i.name = "Invariant Violation", i;
        }
      }

      function e() {
        return t;
      }

      t.isRequired = t;
      var n = {
        array: t,
        bool: t,
        func: t,
        number: t,
        object: t,
        string: t,
        symbol: t,
        any: t,
        arrayOf: e,
        element: t,
        elementType: t,
        instanceOf: e,
        node: t,
        objectOf: e,
        oneOf: e,
        oneOfType: e,
        shape: e,
        exact: e,
        checkPropTypes: o,
        resetWarningCache: a
      };
      return n.PropTypes = n, n;
    };
  }, function (t, e, n) {
    "use strict";

    t.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }]);
}, function (t, e, n) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = function (t) {
    return t.replace(/\n/g, "").replace(/\s\s+/g, " ");
  };
}, function (t, e, n) {
  "use strict";

  var r = n(5);

  function a() {}

  function o() {}

  o.resetWarningCache = a, t.exports = function () {
    function t(t, e, n, a, o, c) {
      if (c !== r) {
        var i = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw i.name = "Invariant Violation", i;
      }
    }

    function e() {
      return t;
    }

    t.isRequired = t;
    var n = {
      array: t,
      bool: t,
      func: t,
      number: t,
      object: t,
      string: t,
      symbol: t,
      any: t,
      arrayOf: e,
      element: t,
      elementType: t,
      instanceOf: e,
      node: t,
      objectOf: e,
      oneOf: e,
      oneOfType: e,
      shape: e,
      exact: e,
      checkPropTypes: o,
      resetWarningCache: a
    };
    return n.PropTypes = n, n;
  };
}, function (t, e, n) {
  "use strict";

  t.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}, function (t, e, n) {
  "use strict";

  n.r(e);

  var r = n(1),
      a = n.n(r),
      o = n(0),
      c = n.n(o),
      i = n(2),
      s = n.n(i),
      u = a.a.createContext({}),
      l = n(3),
      p = n.n(l),
      f = function f(t, e) {
    return t ? "".concat(t, " ").concat(e) : e;
  };

  function h(t) {
    return function (t) {
      if (Array.isArray(t)) {
        for (var e = 0, n = new Array(t.length); e < t.length; e++) {
          n[e] = t[e];
        }

        return n;
      }
    }(t) || function (t) {
      if (Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t)) return Array.from(t);
    }(t) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance");
    }();
  }

  var m = function m(t, e, n, r) {
    var a = e + 1,
        o = ".".concat(t, "--hcount-").concat(r ? "".concat(r, "-") : "").concat(a),
        c = "columnWidth" === n ? "calc(100% * ( 1 / (".concat(e + 1, " * 2)))") : n;
    return "\n    ".concat(o, " {\n      grid-template-columns: repeat(").concat(a, ", 1fr);\n      column-gap: ").concat(c, ";\n    }");
  },
      d = function d(t, e, n, r, a, o) {
    var c = h(Array(e).keys()),
        i = Object.keys(a).reverse(),
        s = "",
        u = "".concat(t, "__grid");
    return s += f(o, "\n    .".concat(u, " {\n      display: grid;\n      ").concat(r ? "row-gap: ".concat(r) : null, ";\n    }")), c.forEach(function (t, e) {
      s += f(o, m(u, e, n));
    }), i.forEach(function (t) {
      s += "\n      @media (max-width: ".concat(a[t], "px) {\n        ").concat(c.map(function (e, r) {
        return f(o, m(u, r, n, t));
      }).join(" "), "\n      }\n    ");
    }), s;
  };

  function y(t) {
    return function (t) {
      if (Array.isArray(t)) {
        for (var e = 0, n = new Array(t.length); e < t.length; e++) {
          n[e] = t[e];
        }

        return n;
      }
    }(t) || function (t) {
      if (Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t)) return Array.from(t);
    }(t) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance");
    }();
  }

  var b = function b(t, e, n) {
    var r = e + 1,
        a = ".".concat(t, "--hspan-").concat(n ? "".concat(n, "-") : "").concat(r),
        o = ".".concat(t, "--hstart-").concat(n ? "".concat(n, "-") : "").concat(r);
    return "\n    ".concat(a, ":not(.").concat(t, "--hstart) {\n      grid-column-start: span ").concat(r, ";\n    }\n\n    ").concat(o, " {\n      grid-column-start: ").concat(r, ";\n    }\n\n    .").concat(t, "--hstart").concat(a, " {\n      grid-column-end: span ").concat(r, ";\n    }");
  },
      v = function v(t, e, n, r) {
    var a = y(Array(e).keys()),
        o = Object.keys(n).reverse(),
        c = "",
        i = "".concat(t, "__cell");
    return a.forEach(function (t, e) {
      c += f(r, b(i, e));
    }), o.forEach(function (t) {
      c += "\n      @media (max-width: ".concat(n[t], "px) {\n        ").concat(a.map(function (e, n) {
        return f(r, b(i, n, t));
      }).join(" "), "}\n    ");
    }), c;
  },
      S = function S(t) {
    var e = t.hCount,
        n = t.hGap,
        r = t.vGap,
        o = t.breakpoints,
        c = t.scopeCSSTo,
        i = t.minifyCSS,
        s = t.classPrefix,
        u = d(s, e, n, r, o, c),
        l = v(s, e, o, c),
        f = u.concat(l);
    return a.a.createElement("style", {
      dangerouslySetInnerHTML: {
        __html: i ? p()(f) : f
      }
    });
  };

  S.defaultProps = {
    hGap: "0px",
    vGap: "0px",
    breakpoints: {
      xs: 350,
      s: 576,
      m: 768,
      l: 992,
      xl: 1200
    },
    scopeCSSTo: "",
    minifyCSS: !0,
    classPrefix: ""
  }, S.propTypes = {
    hCount: c.a.number.isRequired,
    hGap: c.a.string,
    vGap: c.a.string,
    breakpoints: c.a.shape({
      xs: c.a.number,
      s: c.a.number,
      m: c.a.number,
      l: c.a.number,
      xl: c.a.number
    }),
    scopeCSSTo: c.a.string,
    minifyCSS: c.a.bool,
    classPrefix: c.a.string
  };
  var O = S;

  function g() {
    return (g = Object.assign || function (t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = arguments[e];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
      }

      return t;
    }).apply(this, arguments);
  }

  var x = function x(t) {
    var e = t.hCount,
        n = t.hCountOverrides,
        o = t.hGap,
        c = t.vGap,
        i = t.children,
        s = t.renderStyleSheet,
        l = t.breakpoints,
        p = t.scopeCSSTo,
        f = t.classPrefix;
    return a.a.createElement(r.Fragment, null, s && a.a.createElement(O, g({
      hCount: e,
      hGap: o,
      vGap: c,
      breakpoints: l,
      scopeCSSTo: p
    }, {
      classPrefix: f || "trbl"
    })), a.a.createElement(u.Provider, {
      value: {
        hCount: e,
        hCountOverrides: n,
        hGap: o,
        vGap: c,
        classPrefix: f || "trbl"
      }
    }, i));
  };

  x.defaultProps = {
    hGap: "0px",
    vGap: "0px",
    breakpoints: {
      xs: 350,
      s: 576,
      m: 768,
      l: 992,
      xl: 1200
    },
    renderStyleSheet: !0,
    scopeCSSTo: "",
    minifyCSS: !0,
    hCountOverrides: void 0,
    classPrefix: ""
  }, x.propTypes = {
    children: c.a.oneOfType([c.a.node, c.a.arrayOf(c.a.node)]).isRequired,
    renderStyleSheet: c.a.bool,
    hCount: c.a.number.isRequired,
    hCountOverrides: c.a.shape({
      xs: c.a.number,
      s: c.a.number,
      m: c.a.number,
      l: c.a.number,
      xl: c.a.number
    }),
    hGap: c.a.oneOfType([c.a.oneOf(["columnWidth"]), c.a.string]),
    vGap: c.a.string,
    breakpoints: c.a.shape({
      xs: c.a.number,
      s: c.a.number,
      m: c.a.number,
      l: c.a.number,
      xl: c.a.number
    }),
    scopeCSSTo: c.a.string,
    minifyCSS: c.a.bool,
    classPrefix: c.a.string
  };
  var P = x;

  function j() {
    return (j = Object.assign || function (t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = arguments[e];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
      }

      return t;
    }).apply(this, arguments);
  }

  var T = function T(t) {
    var e = t.id,
        n = t.className,
        r = t.hSpan,
        o = t.hSpanXS,
        c = t.hSpanS,
        i = t.hSpanM,
        l = t.hSpanL,
        p = t.hSpanXL,
        f = t.hStart,
        h = t.hStartXS,
        m = t.hStartS,
        d = t.hStartM,
        y = t.hStartL,
        b = t.hStartXL,
        v = t.style,
        S = t.htmlElement,
        O = t.htmlAttributes,
        g = t.children,
        x = {
      xs: o,
      s: c,
      m: i,
      l: l,
      xl: p
    };
    return a.a.createElement(u.Consumer, null, function (t) {
      var u = t.columnGap,
          T = t.rowGap,
          _ = t.classPrefix,
          C = "".concat(_, "__cell"),
          E = [C, r && "".concat(C, "--hspan-").concat(r), o && "".concat(C, "--hspan-xs-").concat(o), c && "".concat(C, "--hspan-s-").concat(c), i && "".concat(C, "--hspan-m-").concat(i), l && "".concat(C, "--hspan-l-").concat(l), p && "".concat(C, "--hspan-xl-").concat(p), (f || h || m || d || y || b) && "".concat(C, "--hstart"), f && "".concat(C, "--hstart-").concat(f), h && "".concat(C, "--hstart-xs-").concat(h), m && "".concat(C, "--hstart-s-").concat(m), d && "".concat(C, "--hstart-m-").concat(d), y && "".concat(C, "--hstart-l-").concat(y), b && "".concat(C, "--hstart-xl-").concat(b), n].filter(Boolean).join(" ");
      return a.a.createElement(P, j({
        hCount: r,
        renderStyleSheet: !1
      }, {
        columnGap: u,
        rowGap: T,
        hCountOverrides: x,
        classPrefix: _
      }), a.a.createElement(s.a, {
        id: e,
        className: E,
        style: v,
        htmlElement: S,
        htmlAttributes: O
      }, g && g));
    });
  };

  T.defaultProps = {
    id: void 0,
    className: void 0,
    hSpan: void 0,
    hSpanXS: void 0,
    hSpanS: void 0,
    hSpanM: void 0,
    hSpanL: void 0,
    hSpanXL: void 0,
    hStart: void 0,
    hStartXS: void 0,
    hStartS: void 0,
    hStartM: void 0,
    hStartL: void 0,
    hStartXL: void 0,
    style: {},
    htmlElement: "div",
    htmlAttributes: {},
    children: void 0
  }, T.propTypes = {
    id: c.a.string,
    className: c.a.string,
    hSpan: c.a.number,
    hSpanXS: c.a.number,
    hSpanS: c.a.number,
    hSpanM: c.a.number,
    hSpanL: c.a.number,
    hSpanXL: c.a.number,
    hStart: c.a.number,
    hStartXS: c.a.number,
    hStartS: c.a.number,
    hStartM: c.a.number,
    hStartL: c.a.number,
    hStartXL: c.a.number,
    style: c.a.shape({}),
    htmlElement: c.a.string,
    htmlAttributes: c.a.shape({}),
    children: c.a.oneOfType([c.a.node, c.a.arrayOf(c.a.node)])
  };

  var _ = T,
      C = function C(t) {
    var e = t.id,
        n = t.className,
        r = t.style,
        o = t.htmlElement,
        c = t.htmlAttributes,
        i = t.children;
    return a.a.createElement(u.Consumer, null, function (t) {
      var u = t.hCount,
          l = t.hCountOverrides,
          p = (l = void 0 === l ? {} : l).xs,
          f = l.s,
          h = l.m,
          m = l.l,
          d = l.xl,
          y = t.classPrefix,
          b = "".concat(y, "__grid"),
          v = [b, u && "".concat(b, "--hcount-").concat(u), p && "".concat(b, "--hcount-xs-").concat(p), f && "".concat(b, "--hcount-s-").concat(f), h && "".concat(b, "--hcount-m-").concat(h), m && "".concat(b, "--hcount-l-").concat(m), d && "".concat(b, "--hcount-xl-").concat(d), n].filter(Boolean).join(" ");
      return a.a.createElement(s.a, {
        id: e,
        className: v,
        style: r,
        htmlElement: o,
        htmlAttributes: c
      }, i && i);
    });
  };

  C.defaultProps = {
    id: void 0,
    className: void 0,
    style: {},
    htmlElement: "div",
    htmlAttributes: {},
    children: void 0
  }, C.propTypes = {
    id: c.a.string,
    className: c.a.string,
    style: c.a.shape({}),
    htmlElement: c.a.string,
    htmlAttributes: c.a.shape({}),
    children: c.a.oneOfType([c.a.node, c.a.arrayOf(c.a.node)])
  };
  var E = C;
  n.d(e, "Cell", function () {
    return _;
  }), n.d(e, "Grid", function () {
    return E;
  }), n.d(e, "GridContext", function () {
    return u;
  }), n.d(e, "GridProvider", function () {
    return P;
  });
}]);